import React, { useState, useEffect, useCallback } from "react";
import useCartStore from "../../stores/useCartStore";
import {
  GetShopLicenses,
  GetStudentsWithLicense,
} from "../../actions/adminQueries";
import {
  Card,
  CardTitle,
  Row,
  Col,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import ProductItem from "./ProductItem";
import { PacmanLoader } from "react-spinners";
import {
  GetTeacherInformation,
  GetTeacherStudents,
} from "../../actions/teacherQueries";
import AplProductItem from "./AplProductItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ShopStudentsSelect from "./ShopStudentsSelect";
import NewCart from "./NewCart";
import { formatDate, toDate } from "../../Utilities/dateUtils";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import { LicenseTypes } from "../../constants/LicenseTypes";
import {
  AstarFortNoxArticleNumbers,
  AstarCustomerGroupId,
  ExcludedLicensesForAstar,
  InternalEmails,
} from "../../constants/ConstantVars";

const ProductsList = (props) => {
  const [currency, setCurrency] = useState("SEK");
  const [animateStudents, setAnimateStudents] = useState(false);
  const [collapseProducts, setCollapseProducts] = useState(false);
  const [collapseStudents, setCollapseStudents] = useState(true);
  const [licenseInfoModalIsOpen, setLicenseInfoModalIsOpen] = useState(false);
  const [sortedLicenses, setSortedLicenses] = useState([]);
  const [sortedGenericAplLicenses, setSortedGenericAplLicenses] = useState([]);
  const [studentsOnCurrentProgram, setStudentsOnCurrentProgram] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const cart = useCartStore();
  const school = JSON.parse(localStorage.getItem("school"));

  const products = GetShopLicenses(school?.id);
  const students = GetTeacherStudents();
  const teacherInfo = GetTeacherInformation();
  const studentWithLicenses = GetStudentsWithLicense(school?.id);
  const handleSetStudentsOnProgram = useCallback(
    (costCenter) => {
      if (!studentWithLicenses.isPending && students.data) {
        const studentsOnProgram = [];
        students.data.forEach((stud) => {
          if (
            stud.class.programme.costCenter === costCenter ||
            cart.lastAddedItem.type === LicenseTypes.APLOnly
          ) {
            const licenses = studentWithLicenses.data.find(
              (lic) => lic.studentId === stud.id,
            );
            studentsOnProgram.push({
              name: stud.name,
              id: stud.id,
              class: { name: stud.class.name, id: stud.class.id },
              licenses: licenses,
            });
          }
        });
        setStudentsOnCurrentProgram(studentsOnProgram);
      }
    },
    [
      cart.lastAddedItem.type,
      studentWithLicenses.data,
      students.data,
      studentWithLicenses.isPending,
    ],
  );

  useEffect(() => {
    if (!teacherInfo.isPending && teacherInfo.data?.customer) {
      setCurrency(teacherInfo.data.customer.currency);
    }
  }, [teacherInfo.data, teacherInfo.isPending]);

  useEffect(() => {
    if (!_.isEmpty(cart.lastAddedItem)) {
      handleSetStudentsOnProgram(
        cart.lastAddedItem.isPlusPackage
          ? cart.lastAddedItem.studentLicense.costCenter
          : cart.lastAddedItem.costCenter,
      );
    }
  }, [cart.lastAddedItem, handleSetStudentsOnProgram]);

  const dispachPackageAddToCart = (itemToAdd, plusPackageToAdd) => {
    itemToAdd.validFrom = itemToAdd.validFrom
      ? itemToAdd.validFrom
      : new Date();
    itemToAdd.addedStudents = [];
    if (plusPackageToAdd) {
      const itemToSetAsLastAdded = {
        isPlusPackage: true,
        plusPackage: { ...plusPackageToAdd, validFrom: itemToAdd.validFrom },
        studentLicense: itemToAdd,
      };
      cart.setLastAddedItem(itemToSetAsLastAdded);
      cart.addToCart({
        ...plusPackageToAdd,
        validFrom: plusPackageToAdd.startDate,
        name:
          plusPackageToAdd.name +
          " (giltig från " +
          formatDate(plusPackageToAdd.startDate, "yyyy-MM-dd") +
          ")",
      });
      cart.addToCart(itemToAdd);
    } else {
      if (itemToAdd.type === LicenseTypes.PlusLicense) {
        cart.setLastAddedItem(itemToAdd);
        cart.addToCart({
          ...itemToAdd,
          validFrom: itemToAdd.startDate,
          name:
            itemToAdd.name +
            " (giltig från " +
            formatDate(itemToAdd.startDate, "yyyy-MM-dd") +
            ")",
        });
        cart.addToCart(itemToAdd);
      } else {
        let tempItemToAdd = { ...itemToAdd };
        if (itemToAdd.type === LicenseTypes.APLOnly) {
          tempItemToAdd.name =
            itemToAdd.name +
            " (giltig från " +
            formatDate(itemToAdd.startDate, "yyyy-MM-dd") +
            ")";
        }
        if (
          AstarFortNoxArticleNumbers.includes(itemToAdd.fortnoxNumber) &&
          products.data.customerGroupId === AstarCustomerGroupId
        ) {
          tempItemToAdd.name = itemToAdd.name + " & APL By LearnWARE 2 år";
        }
        cart.setLastAddedItem(tempItemToAdd);
        cart.addToCart(tempItemToAdd);
      }
    }
    handleSetStudentsOnProgram(itemToAdd.costCenter);
    toggle();
    setAllChecked(false);
  };

  const toggle = () => {
    setAnimateStudents(!animateStudents);
    setCollapseProducts(true);
  };

  const toggleProducts = () => {
    setCollapseProducts(!collapseProducts);
  };

  const removeManyFromCart = (students) => {
    let studentIds = [];
    students.forEach((stud) => {
      studentIds.push(stud.id);
    });
    if (cart.lastAddedItem.isPlusPackage) {
      cart.removeManyStudentsFromCartAndLastAdded(
        studentIds,
        cart.lastAddedItem.studentLicense.fortnoxNumber
      );
      cart.removeManyStudentsFromCartAndLastAdded(
        studentIds,
        cart.lastAddedItem.plusPackage.fortnoxNumber
      );
    } else {
      cart.removeManyStudentsFromCartAndLastAdded(
        studentIds,
        cart.lastAddedItem.fortnoxNumber
      );
    }
  };

  const addManyToCart = (students) => {
    if (cart.lastAddedItem.isPlusPackage) {
      cart.addManyStudentsToCartAndLastAdded(
        students,
        cart.lastAddedItem.studentLicense.fortnoxNumber
      );
      cart.addManyStudentsToCartAndLastAdded(
        students,
        cart.lastAddedItem.plusPackage.fortnoxNumber
      );
    } else {
      cart.addManyStudentsToCartAndLastAdded(
        students,
        cart.lastAddedItem.fortnoxNumber
      );
    }
  };

  const addOrRemoveStudentFromCartItem = (student) => {
    //ADD or Remove student based on cart users.
    if (cart.lastAddedItem.isPlusPackage) {
      if (
        cart.lastAddedItem.studentLicense.addedStudents.some(
          (stud) => stud.id === student.id
        ) ||
        cart.lastAddedItem.plusPackage.addedStudents.some(
          (stud) => stud.id === student.id
        )
      ) {
        //Remove student
        cart.removeStudentFromCartItem(
          student,
          cart.lastAddedItem.studentLicense.fortnoxNumber
        );
        cart.removeStudentFromCartItem(
          student,
          cart.lastAddedItem.plusPackage.fortnoxNumber
        );
        //Remove from lastaddeditem from cart.lastAddedItem.plusPackage.addedStudents And cart.lastAddedItem.studentLicense.addedStudents
        let tempLastAddedItem = { ...cart.lastAddedItem };
        tempLastAddedItem.plusPackage.addedStudents =
          tempLastAddedItem.plusPackage.addedStudents.filter(
            (stud) => stud.id !== student.id
          );

        tempLastAddedItem.studentLicense.addedStudents =
          tempLastAddedItem.studentLicense.addedStudents.filter(
            (stud) => stud.id !== student.id
          );
        cart.setLastAddedItem(tempLastAddedItem);
      } else {
        //Add student
        if (
          !cart.result
            .find(
              (item) =>
                item.fortnoxNumber ===
                cart.lastAddedItem.studentLicense.fortnoxNumber
            )
            .addedStudents.some((stud) => stud.id === student.id)
        ) {
          cart.addStudentToCartItem(
            student,
            cart.lastAddedItem.studentLicense.fortnoxNumber
          );
        }
        //Block add if student already exists in cart.result
        if (
          !cart.result
            .find(
              (item) =>
                item.fortnoxNumber ===
                cart.lastAddedItem.plusPackage.fortnoxNumber
            )
            .addedStudents.some((stud) => stud.id === student.id)
        ) {
          cart.addStudentToCartItem(
            student,
            cart.lastAddedItem.plusPackage.fortnoxNumber
          );
        }
        //Add to lastaddeditem to cart.lastAddedItem.plusPackage.addedStudents
        let tempLastAddedItem = { ...cart.lastAddedItem };
        if (
          !tempLastAddedItem.plusPackage.addedStudents.some(
            (stud) => stud.id === student.id
          )
        ) {
          tempLastAddedItem.plusPackage.addedStudents.push(student);
        }
        //And cart.lastAddedItem.studentLicense.addedStudents
        if (
          !tempLastAddedItem.studentLicense.addedStudents.some(
            (stud) => stud.id === student.id
          )
        ) {
          tempLastAddedItem.studentLicense.addedStudents.push(student);
        }
        cart.setLastAddedItem(tempLastAddedItem);
      }
      //If lastAddedItem is not pluspackage
    } else {
      if (
        cart.lastAddedItem.addedStudents.some((stud) => stud.id === student.id)
      ) {
        //Remove student
        cart.removeStudentFromCartItem(student, cart.lastAddedItem.fortnoxNumber);
        //Remove from lastaddeditem from cart.lastAddedItem.addedStudents
        let tempLastAddedItem = { ...cart.lastAddedItem };
        tempLastAddedItem.addedStudents =
          tempLastAddedItem.addedStudents.filter(
            (stud) => stud.id !== student.id
          );
        cart.setLastAddedItem(tempLastAddedItem);
      } else {
        //Add student
        if (
          !cart.result
            .find(
              (item) => item.fortnoxNumber === cart.lastAddedItem.fortnoxNumber
            )
            .addedStudents.some((stud) => stud.id === student.id)
        ) {
          cart.addStudentToCartItem(student, cart.lastAddedItem.fortnoxNumber);
        }
        //Add to lastaddeditem to cart.lastAddedItem.addedStudents
        let tempLastAddedItem = { ...cart.lastAddedItem };
        if (
          !tempLastAddedItem.addedStudents.some(
            (stud) => stud.id === student.id
          )
        ) {
          tempLastAddedItem.addedStudents.push(student);
        }
        cart.setLastAddedItem(tempLastAddedItem);
      }
    }
  };

  useEffect(() => {
    if (!products.isPending && products.data) {
      let tempSortedLicenses = [];
      products.data.options.forEach((lic) => {
        let tempProd = {
          customerGroupId: products.data.customerGroupId,
          programLicenseId: lic.programLicense.id,
          programName: lic.programLicense.fortNoxProgram.programName,
          addedDate: lic.programLicense.addedDate,
          fortnoxNumber:
            lic.programLicense.fortNoxProgram
              .fortNoxStudentProgramLicenseNumber,
          name: lic.programLicense.name,
          imgUrl: lic.programLicense.fortNoxProgram.imgUrl || null,
          price: lic.programLicense.price,
          validTo: lic.programLicense.validTo,
          fortNoxCostCenter:
            lic.programLicense.fortNoxProgram.fortNoxCostCenter,
          options: [],
        };
        tempProd.options.push({
          type: LicenseTypes.StudentLicense,
          name: lic.studentLicense.description,
          fortnoxNumber: lic.studentLicense.articleNumber,
          priceStudent: Number(lic.studentLicense.salesPrice),
          programLicenseId: lic.programLicense.id,
          costCenter: lic.programLicense.fortNoxProgram.fortNoxCostCenter,
        });

        //Add the license with plus package
        tempProd.options.push({
          type: LicenseTypes.StudentLicencePlus,
          name: "LearnWARE Pluspaket",
          options: [],
        });
        products.data.aplBundle.forEach((licOpt) => {
          let tempItemToAdd = {
            fortnoxNumber: licOpt.articleNumber,
            priceStudent: Number(licOpt.salesPrice),
            years: licOpt.years,
            name: licOpt.description,
          };
          tempProd.options
            .find(
              (licenseOption) =>
                licenseOption.type === LicenseTypes.StudentLicencePlus,
            )
            .options.push(tempItemToAdd);
        });

        //Add the plus package
        tempProd.options.push({
          type: LicenseTypes.PlusLicense,
          name: "Enbart pluspaket",
          options: [],
        });
        products.data.aplBundle.forEach((licOpt) => {
          let tempItemToAdd = {
            fortnoxNumber: licOpt.articleNumber,
            priceStudent: Number(licOpt.salesPrice),
            years: licOpt.years,
            name: licOpt.description,
          };
          tempProd.options
            .find(
              (licenseOption) =>
                licenseOption.type === LicenseTypes.PlusLicense,
            )
            .options.push(tempItemToAdd);
        });
        tempSortedLicenses.push(tempProd);
      });
      setSortedLicenses(tempSortedLicenses);
      let tempOptionsForGeneric = [];
      products.data.aplStandAlone.forEach((option) => {
        tempOptionsForGeneric.push({
          ...option,
          fortnoxNumber: option.articleNumber,
        });
      });
      let tempSortedGenericAplLicenses = {
        name: "APL By Learnware",
        options: tempOptionsForGeneric,
      };
      setSortedGenericAplLicenses(tempSortedGenericAplLicenses);
    }
  }, [products.data, products.isPending]);

  if (
    products.isPending === true ||
    teacherInfo.isPending === true ||
    studentWithLicenses.isPending === true ||
    students.isPending === true
  ) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  let productList = [];
  if (sortedLicenses.length) {
    productList = sortedLicenses.map((p, i) => {
      let available = teacherInfo.data.programmes.filter(
        (x) => x.costCenter === p.fortNoxCostCenter,
      );

      const isAstar = p.customerGroupId === AstarCustomerGroupId;
      const isInternalEamil = InternalEmails.includes(teacherInfo.data.email);

      const isLicenseExcluded =
        isAstar &&
        ExcludedLicensesForAstar.includes(p.fortnoxNumber) &&
        !isInternalEamil;

      if ((!available.length > 0 && props.inModal) || isLicenseExcluded) {
        return null;
      } else {
        var productPlusLicenses = p.options?.find(
          (item) => item.type === "PlusLicense",
        );
        if (productPlusLicenses) {
          var licenseWithLowestPrice = productPlusLicenses.options.reduce(
            (prev, curr) =>
              prev.priceStudent / prev.years < curr.priceStudent / curr.years
                ? prev
                : curr,
          );
        }
        return (
          <ProductItem
            key={"productItem" + i}
            cart={cart}
            lastAddedProduct={cart.lastAddedItem}
            handleOnAddPackage={dispachPackageAddToCart.bind(this)}
            inModal={props.inModal ? props.inModal : false}
            enablePackage={available.length > 0}
            isExpired={toDate(p.validTo) < new Date()}
            product={p}
            currency={currency}
            cheapestPlusLicensePrice={
              licenseWithLowestPrice.priceStudent / licenseWithLowestPrice.years
            }
          />
        );
      }
    });
  }
  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl="11" lg="12">
          <Card body style={{ marginBottom: "29px" }}>
            <Row>
              <Col lg="12" className="d-flex">
                <div
                  style={{ width: "25px", height: "25px" }}
                  className={
                    Object.keys(cart).length > 0
                      ? "bg-success rounded-circle ps-1 pe-1 text-center align-middle lead float-start me-4"
                      : "bg-primary  rounded-circle ps-1 pe-1 text-center align-middle lead float-start me-4 animated bounce"
                  }
                >
                  <FontAwesomeIcon
                    icon="check"
                    className={Object.keys(cart).length > 0 ? "" : "d-none"}
                  />
                  <strong
                    className={Object.keys(cart).length === 0 ? "" : "d-none"}
                  >
                    1
                  </strong>
                </div>
                <CardTitle
                  onClick={toggleProducts}
                  style={{ width: "80%", cursor: "pointer" }}
                  className="animated bounce mb-0"
                >
                  <h5 className="pb-0 mb-0">
                    {!collapseProducts ? (
                      <FontAwesomeIcon className="me-2" icon="chevron-down" />
                    ) : (
                      <FontAwesomeIcon className="me-2" icon="chevron-right" />
                    )}
                    <FormattedMessage id="ChooseLicensePackage" />
                  </h5>
                </CardTitle>

                <Button
                  size="xs"
                  style={{
                    position: "absolute",
                    top: "1.5em",
                    left: "18.3em",
                    marginTop: "0px",
                    marginLeft: "2em",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    fontSize: ".8em",
                    padding: "0",
                  }}
                  onClick={() => setLicenseInfoModalIsOpen(true)}
                  outline
                  color="primary"
                >
                  <FontAwesomeIcon icon="info" />
                </Button>
              </Col>

              <Col lg="12" md="12" xs="12">
                <Collapse
                  isOpen={!collapseProducts}
                  style={{ paddingTop: "20px" }}
                >
                  <Row className="ms-0 me-0">
                    <div className="shop-cards_container">
                      {productList}

                      <AplProductItem
                        currency={currency}
                        lastAddedProduct={cart.lastAddedItem}
                        handleOnAddPackage={dispachPackageAddToCart.bind(this)}
                        enablePackage={true}
                        product={sortedGenericAplLicenses}
                        hasOtherProgramLicenses={
                          products.data?.options?.filter(
                            (plic) => !plic.programLicense.hasExpired,
                          ).length > 0
                        }
                      />
                    </div>
                  </Row>
                </Collapse>
              </Col>
            </Row>
          </Card>

          <Card body style={{ marginBottom: "29px" }}>
            <Row>
              <Col lg="12" className="d-flex">
                <div
                  style={{ width: "25px", height: "25px" }}
                  className={
                    Object.keys(cart.result).length > 0
                      ? "bg-success animated bounce rounded-circle ps-1 pe-1 text-center align-middle lead float-start me-4"
                      : animateStudents
                        ? "bg-primary animated bounce rounded-circle ps-1 pe-1 text-center align-middle lead float-start me-4"
                        : "bg-secondary rounded-circle ps-1 pe-1 text-center align-middle lead float-start me-4"
                  }
                >
                  <FontAwesomeIcon
                    icon="check"
                    className={
                      Object.keys(cart.result).length > 0 ? "" : "d-none"
                    }
                  />
                  <strong
                    className={
                      Object.keys(cart.result).length > 0 ? "" : "d-none"
                    }
                  ></strong>
                </div>
                <CardTitle
                  className="mb-0"
                  style={{ width: "80%", cursor: "pointer" }}
                  onClick={() => setCollapseStudents(!collapseStudents)}
                >
                  <h5 className="pb-0 mb-0">
                    {collapseStudents ? (
                      <FontAwesomeIcon className="me-2" icon="chevron-down" />
                    ) : (
                      <FontAwesomeIcon className="me-2" icon="chevron-right" />
                    )}
                    <FormattedMessage id="ChooseStudents" />{" "}
                    <span>
                      {cart.lastAddedItem.name &&
                      Object.keys(cart.result).length > 0
                        ? cart.lastAddedItem.name
                        : ""}
                    </span>
                  </h5>
                </CardTitle>
              </Col>
              <Col lg="12">
                <Collapse
                  style={{ paddingTop: "20px" }}
                  isOpen={
                    Object.keys(cart.result).length > 0 && collapseStudents
                  }
                >
                  <ShopStudentsSelect
                    studentsOnCurrentProgram={studentsOnCurrentProgram}
                    preselectedStudent={props.preselectedStudent}
                    lastAddedProduct={cart.lastAddedItem}
                    addOrRemoveStudentFromCartItem={
                      addOrRemoveStudentFromCartItem
                    }
                    allStudentsWithLicenses={studentWithLicenses}
                    allStudents={students.data}
                    removeManyFromCart={removeManyFromCart}
                    addManyToCart={addManyToCart}
                    allChecked={allChecked}
                    setAllChecked={setAllChecked}
                  />
                </Collapse>
              </Col>
            </Row>
          </Card>
          <Card>
            <NewCart currency={currency} />
          </Card>
        </Col>
      </Row>

      <Modal
        isOpen={licenseInfoModalIsOpen}
        toggle={() => setLicenseInfoModalIsOpen(false)}
      >
        <ModalHeader>
          <FormattedMessage id="Licenses" />
        </ModalHeader>
        <ModalBody>
          <Row className="pt-3 px-3">
            <strong>
              <FormattedMessage id="StudentLicense" />:{" "}
            </strong>{" "}
            <FormattedMessage id="ProgramLicenseStoreInfo" />
          </Row>
          <Row className="pt-3 px-3">
            <strong>
              <FormattedMessage id="StudentLicensePlus" />:{" "}
            </strong>{" "}
            <FormattedMessage id="ProgramLicensePlusStoreInfo" />
          </Row>
          <Row className="pt-3 px-3">
            <strong>
              <FormattedMessage id="OnlyPlusPackage" />:{" "}
            </strong>{" "}
            <FormattedMessage id="OnlyPlusPackageStoreInfo" />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            outline
            color="primary"
            onClick={() => setLicenseInfoModalIsOpen(false)}
          >
            <FormattedMessage id="Ok" />
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default ProductsList;
